import setAgentPreferences from 'actions/agent_preferences/set_agent_preferences';
import { ThemeMode } from 'models/agent_preferences';
import { setTheme } from 'scripts/presentation/themes/theme_toggle';

// The gladly-theme localStorage key (written by setTheme) is the live source for
// synchronous first paint; agentPreferences.themeMode is the persisted copy that
// survives a browser data wipe and syncs across devices.
export default class SetTheme {
  constructor(context) {
    this.context = context;
  }

  run({ theme }) {
    setTheme(theme);

    const preferences = this.context.stores.agentPreferences.get();
    preferences.setThemeMode(theme === 'dark' ? ThemeMode.DARK : ThemeMode.LIGHT);
    setAgentPreferences(this.context, preferences);
  }
}
